import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-regular-left.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/currencyDisplay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/vendor/[name]/[id]/vendorDetailProductRecommendations.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/design-system/breadcrumbs/breadcrumbs.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/vendor/[name]/[id]/vendorDetails.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/star-rating/starRating.tsx");
